/*
 * @Author: 卢靖康
 * @Date: 2019-10-31 17:55:50
 * @LastEditTime: 2022-11-08 11:18:53
 * @LastEditors: 卢靖康
 */
export default {
    首页:'Startseite',
    NBHX:'NBHX',
    关于华翔:'Über NBHX',
    // 使命愿景:'Mission & Vision',
    荣誉奖项:'Auszeichnungen & Awards',
    主要客户:'Key Kunden',
    全球分布:'Globales Netzwerk',
    合作伙伴:'Partner',
    联系我们:'Kontaktieren Sie uns',
    廉洁合规:'Integrität und Compliance',

    新闻资讯:'News',
    媒体报道:'Pressemitteilung',
    企业新闻:'NBHX News',
    行业动态:'Industry News',

    核心业务:'Kerngeschäft',
    装饰条:'Zierteile',
    内外饰件:'Interieur & Exterieur',
    车身金属件:'Metallteile',
    车身电子:'Elektronik',
    // 轻量化材料:'轻量化材料',
    // 新能源电池包:'新能源电池包',

    人力资源:'Personalbereich',
    招贤纳士:'Kommen Sie zu uns',
    人才发展:'Talentförderung',

    投资者关系:'Investorenbetreuung',
    股票信息:'Aktien-Informationen',
    最新公告:'Bekanntmachungen',
    公司治理:'Unternehmensführung',

    关注我们:'Folgen Sie uns',

    查看更多:'Mehr Informationen',

    tel:'Tel',
    date:'Date',
    author:'Author',
    source:'Source',
    copyright:'Ningbo Huaxiang Group Co., Ltd. All rights reserved. Copyright2022'
}
